import { cx } from '@twind/core';
import { Category } from 'app/services/helpCenter';
import { Title } from 'app/components/Typography';
import useFeatureFlags from 'app/hooks/useFeatureFlags';
import { useNavigate } from 'react-router-dom';
import useWebchatVersion from 'app/hooks/useWebchatVersion';
import { useTailorHalfOpen } from 'app/hooks/useTailorHalfOpen';
import { ChatModuleType, SuggestedEntry } from 'app/copied/models/ChatModules';
import useModule from 'app/hooks/useModule';
import { ChatVersion } from 'app/copied/constants/common';

import TailorCategories from '../../components/TailorCategories';
import TailorMostRequested from '../../components/TailorMostRequested';
import useTailorTracking from '../../hooks/useTailorTracking';

export default function TailorLandingCategories({
  categories,
  onClickFaq,
}: {
  categories: Category[];
  onClickFaq: (result: SuggestedEntry, index: number) => void;
}) {
  const { uiRefreshReduceWhitespaceBetweenCategories, uiRefreshSuggestedArticlesHeading } = useFeatureFlags();
  const navigate = useNavigate();
  const { captureLandingPageCategoryClicked } = useTailorTracking();
  const webchatVersion = useWebchatVersion();
  const { halfOpen } = useTailorHalfOpen();
  const tailorModule = useModule(ChatModuleType.TAIlor);

  const containerPadding = webchatVersion === ChatVersion.v4_1 ? 'pt-9' : 'pt-5';

  return (
    <div
      className={cx(
        containerPadding,
        'px-7 grow',
        uiRefreshReduceWhitespaceBetweenCategories ? 'pb-10 mb-[-1px]' : 'pb-16'
      )}
    >
      {categories.length > 0 && (
        <TailorCategories
          className="mt-6"
          onClickCategory={(category, index) => {
            navigate(`/tailor/category/${encodeURIComponent(category.name)}`);
            captureLandingPageCategoryClicked(category, {
              resultIndex: index + 1,
              halfAutoOpen: halfOpen,
            });
          }}
          categories={categories}
        />
      )}
      {categories.length === 0 && (
        <TailorMostRequested
          title={uiRefreshSuggestedArticlesHeading || (webchatVersion === ChatVersion.v4_1 ? undefined : '')}
          showArticleDescriptions={false}
          articleTitleComponent={Title}
          searchResults={tailorModule?.config?.suggested_entries}
          onSelectResult={onClickFaq}
        />
      )}
    </div>
  );
}
